<div
  *ngIf="room"
  class="h-screen w-full flex flex-col bg-white"
  style="min-height: -webkit-fill-available"
>
  <ts-infosystem-toolbar
    *ngIf="room?.id"
    [schoolId]="school?.id"
    [room]="room"
  ></ts-infosystem-toolbar>
  <!--
    Overview mode: the gallery is a fixed 16:9 box whose width (2/3 of the row)
    drives its height. self-start keeps it at its aspect-ratio height instead of
    stretching to the row, and the right column flexes to match it — so a 16:9
    image fills the box exactly: no crop, no bars. (Inline aspect-ratio because
    the @tailwindcss/aspect-ratio plugin disables Tailwind's aspect-* classes.)
  -->
  <div
    *ngIf="room?.showInOverview"
    class="flex flex-col h-full min-h-0 gap-4 m-4 max-h-exceptTvMenu"
  >
    <div class="flex gap-4 min-h-0">
      <div class="basis-2/3 shrink-0 self-start" style="aspect-ratio: 16 / 9" *ngIf="school?.id">
        <ts-infosystem-gallery
          class="block h-full w-full"
          [schoolId]="school?.id"
        ></ts-infosystem-gallery>
      </div>

      <div class="flex flex-1 flex-col gap-4 min-w-0">
        <ts-infosystem-events
          class="flex flex-1 items-center"
          *ngIf="school?.id"
          [schoolId]="school?.id"
        >
        </ts-infosystem-events>
        <ts-infosystem-hvv
          class="flex-[2]"
          [schoolId]="school?.id"
          [stationName]="school?.stationName"
        >
        </ts-infosystem-hvv>
        <ts-infosystem-weather
          class="flex-1"
          *ngIf="school?.id"
          [lat]="school.lat"
          [lng]="school.lng"
        >
        </ts-infosystem-weather>
      </div>
    </div>

    <div class="flex flex-1 gap-4 min-h-0">
      <ts-infosystem-rss
        class="relative basis-1/3 shrink-0 rounded-2xl shadow-lg overflow-hidden flex flex-col"
        [schoolId]="school?.id"
      >
      </ts-infosystem-rss>
      <ts-infosystem-featured-courses
        class="flex-1 min-w-0"
        *ngIf="school?.id"
        [schoolId]="school?.id"
        [showInOverview]="true"
      >
      </ts-infosystem-featured-courses>
    </div>
  </div>

  <!--
    Non-overview mode: upcoming courses left, events + a 16:9 gallery stacked on
    the right, featured courses as a full-width strip below. Flex (not the fixed
    grid) so events grows to fit its content instead of being clipped, and the
    gallery keeps a true 16:9 frame.
  -->
  <div
    *ngIf="!room?.showInOverview"
    class="flex flex-col h-full min-h-0 gap-4 m-4 max-h-exceptTvMenu"
  >
    <div class="flex flex-1 gap-4 min-h-0">
      <ts-infosystem-upcomming-courses
        class="flex flex-[2] min-w-0"
        *ngIf="school?.id"
        [schoolId]="school?.id"
      >
      </ts-infosystem-upcomming-courses>

      <div class="flex flex-1 flex-col gap-4 min-w-0">
        <ts-infosystem-events
          class="flex flex-1 items-center"
          *ngIf="school?.id"
          [schoolId]="school?.id"
          [maxCount]="4"
        >
        </ts-infosystem-events>

        <!--
          16:9 gallery frame. aspect-ratio lives on a plain block div (not the
          flex item) so its height derives reliably from its definite width; on
          the column's flex item the height-from-width transfer collapses to 0.
          Inline because the @tailwindcss/aspect-ratio plugin disables Tailwind's
          aspect-* utilities.
        -->
        <div class="w-full shrink-0" *ngIf="school?.id">
          <div class="w-full" style="aspect-ratio: 16 / 9">
            <ts-infosystem-gallery
              class="block h-full w-full"
              [schoolId]="school?.id"
            ></ts-infosystem-gallery>
          </div>
        </div>
      </div>
    </div>

    <ts-infosystem-featured-courses
      class="shrink-0"
      *ngIf="school?.id"
      [schoolId]="school?.id"
      [showInOverview]="false"
    >
    </ts-infosystem-featured-courses>
  </div>
</div>
<div
  class="h-screen w-full flex flex-col items-center justify-center bg-orange text-white"
  *ngIf="!hasRoomId"
>
  <h1 class="text-3xl font-bold">Bitte wähle einen Raum aus:</h1>
  <div class="mt-10">
    <table class="prose prose-sm text-white">
      <thead>
        <th class="text-white">ID</th>
        <th class="text-white">Tanzschule</th>
        <th class="text-white">Bezeichnung</th>
        <th class="text-white"></th>
      </thead>
      <tbody>
        <tr *ngFor="let roomItem of rooms">
          <td>{{ roomItem.id }}</td>
          <td>{{ roomItem.school.name }}</td>
          <td>{{ roomItem.name }}</td>
          <td>
            <a
              class="bg-white text-orange px-3 py-1.5 rounded-full shadow-md decoration-transparent"
              [href]="'/?roomId=' + roomItem.id"
              >anzeigen</a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
